import { PaginationState, SortingState } from '@psyomics/ui-components';
import { useCallback, useEffect, useState } from 'react';

import { ReferralSortField } from './generated/referrals';

const DEFAULT_SORTING_STATE: SortingState = [{ id: 'referredAt', desc: true }];
const DEFAULT_PAGE_INDEX = 0;

const isValidSort = (fieldName: string): fieldName is ReferralSortField => {
  return (
    fieldName === ReferralSortField.CompletedAt ||
    fieldName === ReferralSortField.CreatedAt ||
    fieldName === ReferralSortField.Status ||
    fieldName === ReferralSortField.PiSystemId
  );
};

const useResetPageWhenSortFieldChanges = (sortField: string, resetPageIndex: () => void) => {
  useEffect(() => resetPageIndex(), [sortField, resetPageIndex]);
};

const usePagingAndSorting = (defaultPageSize: number) => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: defaultPageSize,
  });
  const [sorting, setSorting] = useState<SortingState>(DEFAULT_SORTING_STATE);
  const sortField = sorting[0]?.id;

  const resetPageIndex = useCallback(() => {
    setPagination({ pageIndex: 0, pageSize: defaultPageSize });
  }, [defaultPageSize]);

  useResetPageWhenSortFieldChanges(sortField, resetPageIndex);

  return { pagination, resetPageIndex, setPagination, setSorting, sorting };
};

export { isValidSort, usePagingAndSorting };
